import { useState, useEffect, useRef } from "react"
import { Portal } from "components"
import { motion, AnimatePresence } from "framer-motion"
import styles from "css/Alert.module.css"
import useApp from "hooks/useApp"
import Lib from "library"

const Alert = ({ alerts }) => {
	//#region Variables
	const App = useApp()
	const completeAction = useRef(null)
	//#endregion

	//#region Methods
	const onClick = (e, id, cb) => {
		console.log("alerts",alerts)
		if(alerts[0].isInputAlert && typeof cb == "function"){
			cb()
		}else{

			completeAction.current = cb
			App.hideAlert(id)
		}
	}

	const onComplete = (type) => {
		if (type === "exit" && completeAction.current) {
			completeAction.current()
			completeAction.current = undefined
		}
	}
	const getMinSec = (n) => {
		// n이 유효한 숫자인지 확인
		if (n == null || isNaN(n) || n < 0) {
			return ""
		}
		
		const d = new Date(Number(n) * 1000)
		const min = d.getMinutes()
		const sec = d.getSeconds()
		return `${min}분 ${Lib.leadingZero(sec)}초`
	}
	//#endregion
	
	return (
		<Portal to='modal'>
			<AnimatePresence>
				{alerts &&
					alerts.map((alert) => {
						if (alert.type === "bottom") {
							return <AlertBottom key={alert.id} alert={alert} onOk={onClick} onCancel={onClick} onComplete={onComplete} getMinSec={getMinSec} />
						} else if (alert.type === "text") {
							return <AlertText key={alert.id} alert={alert} onComplete={onComplete} getMinSec={getMinSec} />
						} else {
							return <AlertWin key={alert.id} alert={alert} onOk={onClick} onCancel={onClick} onComplete={onComplete} getMinSec={getMinSec} />
						}
					})}
			</AnimatePresence>
		</Portal>
	)
}

const AlertBottom = ({ alert, onOk, onCancel, onComplete, getMinSec }) => {
	//#region Variables
	const App = useApp()
	const win = useRef()
	const timer = useRef()
	const [time, setTime] = useState(alert.timer)
	//#endregion

	//#region Variants
	const variants = {
		initial: {
			y: 0,
			transition: {
				type: "tween",
				duration: 0.2,
			},
		},
		animate: {
			y: "-100%",
			transition: {
				type: "tween",
				duration: 0.2,
			},
		},
		exit: {
			y: 0,
			transition: {
				type: "tween",
				duration: 0.2,
			},
		},
	}

	const dimVariants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
	}
	//#endregion

	//#region Effects
	useEffect(() => {
		if (alert.onShow) alert.onShow()
		if (alert.timer && timer.current === undefined) {
			timer.current = setInterval(() => {
				setTime((time) => {
					const newTime = time - 1
					if (newTime <= 0) {
						clearInterval(timer.current)
						timer.current = undefined
						if (alert && alert.onTimer) alert.onTimer(alert)
						return 0
					}
					return newTime
				})
			}, 1000)
		}

		return () => {
			if (timer.current) {
				clearInterval(timer.current)
				timer.current = undefined
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	//#endregion

	return (
		<motion.div variants={dimVariants} initial='initial' animate='animate' exit='initial' className={`${styles.Alert} ${styles.show}`}>
			<motion.div variants={variants} className={`${styles.bottom} ${alert.title && styles["bottom--title"]}`} ref={win} initial='initial' animate='animate' exit='exit' onAnimationComplete={onComplete}>
				{alert.title && <div className={styles.title}>{alert.title}</div>}
				<div className={styles.wrap}>
					{alert.icon && <i className={`${styles.icon} ${alert.icon}`} />}
					{alert.timer && (
						<>
							<i className={`${styles.icon} icon_timer`} />
							<div className={styles.timer}>{getMinSec(time)}</div>
						</>
					)}
					{alert.msg && <div className={styles.main} dangerouslySetInnerHTML={{ __html: alert.msg }} />}
					{/* {alert.msg && alert.msg.replace(/<br \/>|<br>|<br\/>/g, "\n")} */}
					{alert.sub && <div className={styles.sub} dangerouslySetInnerHTML={{ __html: alert.sub }} />}
					{alert.html && <br />}
					{alert.html}
				</div>
				<div className={styles.button_box}>
					{alert.confirm && (
						<button className={styles.button} onClick={(e) => onCancel(e, alert.id, alert.onCancel)}>
							{alert.cancel ?? "취소"}
						</button>
					)}
					<button className={`${styles.button} ${styles.button_ok}`} onClick={(e) => onOk(e, alert.id, alert.onOk)}>
						{alert.ok ?? "확인"}
					</button>
				</div>
				{alert.closeBtn && (
					<i
						className='icon_select_close'
						onClick={(e) => {
							console.log(alert.id)
							App.hideAlert(alert.id)
						}}
					/>
				)}
			</motion.div>
		</motion.div>
	)
}

const AlertText = ({ alert, onComplete, getMinSec }) => {
	
	//#region Variables
	const App = useApp()
	const timer = useRef()
	const [time, setTime] = useState(alert.timer)
	//#endregion

	//#region Variants
	const dimVariants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
		exit: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
	}

	const winVariants = {
		initial: {
			scale: 0,
			opacity: 0,
		},
		animate: {
			scale: 1,
			opacity: 1,
		},
		exit: {
			scale: 0,
			opacity: 0,
		},
	}
	//#endregion
	//#region Effects
	useEffect(() => {
		if (alert.onShow) alert.onShow()
		if (alert.timer && timer.current === undefined) {
			timer.current = setInterval(() => {
				setTime((time) => {
					const newTime = time - 1
					if (newTime <= 0) {
						clearInterval(timer.current)
						timer.current = undefined
						if (alert && alert.onTimer) alert.onTimer(alert)
						return 0
					}
					return newTime
				})
			}, 1000)
		}

		return () => {
			if (timer.current) {
				clearInterval(timer.current)
				timer.current = undefined
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	//#endregion

	return (
		<motion.div className={`${styles.Alert} ${styles.show}`} variants={dimVariants} initial='initial' animate='animate' exit='exit'>
			<motion.div className={styles.window} variants={winVariants} onAnimationComplete={onComplete}>
				{alert.title && <div className={styles.title}>{alert.title}</div>}
				<div className={styles.content}>
					{alert.icon && <i className={`${styles.icon} ${alert.icon}`} />}
					{alert.timer && (
						<>
							<i className={`${styles.icon} icon_timer`} />
							<div className={styles.timer}>{getMinSec(time)}</div>
						</>
					)}
					{alert.msg && <div className={styles.main} dangerouslySetInnerHTML={{ __html: alert.msg }} />}
					{/* {alert.msg && alert.msg.replace(/<br \/>|<br>|<br\/>/g, "\n")} */}
					{alert.sub && <div className={styles.sub} dangerouslySetInnerHTML={{ __html: alert.sub }} />}
					{alert.html && <br />}
					{alert.html}
				</div>
				{/* {alert.closeBtn && <i className='icon_select_close' onClick={(e) => App.hideAlert(alert.id)} />} */}
			</motion.div>
		</motion.div>
	)
}

const AlertWin = ({ alert, onOk, onCancel, onComplete, getMinSec }) => {
	//#region Variables
	const App = useApp()
	const timer = useRef()
	const [time, setTime] = useState(alert.timer)
	//#endregion

	//#region Variants
	const dimVariants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
		exit: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
	}

	const winVariants = {
		initial: {
			scale: 0,
			opacity: 0,
		},
		animate: {
			scale: 1,
			opacity: 1,
		},
		exit: {
			scale: 0,
			opacity: 0,
		},
	}
	//#endregion

	//#region Effects
	useEffect(() => {
		if (alert.onShow) alert.onShow()
		if (alert.timer && timer.current === undefined) {
			timer.current = setInterval(() => {
				setTime((time) => {
					const newTime = time - 1
					if (newTime <= 0) {
						clearInterval(timer.current)
						timer.current = undefined
						if (alert && alert.onTimer) alert.onTimer(alert)
						return 0
					}
					return newTime
				})
			}, 1000)
		}

		return () => {
			if (timer.current) {
				clearInterval(timer.current)
				timer.current = undefined
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (time === 0) {
			clearInterval(timer.current)
			if (alert && alert.onTimer) alert.onTimer(alert)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	//#endregion

	return (
		<motion.div className={`${styles.Alert} ${styles.show}`} variants={dimVariants} initial='initial' animate='animate' exit='exit'>
			<motion.div className={styles.window} variants={winVariants} onAnimationComplete={onComplete}>
				<div className={styles.header}>
				{alert.isEdoc && alert.isClose && <div className={styles.right}><i className='icon_close' onClick={(e) => onCancel(e, alert.id, null)} /></div>}
				</div>
				{alert.title && <div className={styles.title}>{alert.title}</div>}
				<div className={styles.content}>
					{alert.icon && <i className={`${styles.icon} ${alert.icon}`} />}
					{alert.timer && (
						<>
							<i className={`${styles.icon} icon_timer`} />
							<div className={styles.timer}>{getMinSec(time)}</div>
						</>
					)}
					{alert.msg && <div className={alert.isEdoc ? styles.eDoc_main: styles.main} dangerouslySetInnerHTML={{ __html: alert.msg }} />}
					{/* {alert.msg && alert.msg.replace(/<br \/>|<br>|<br\/>/g, "\n")} */}
					{alert.sub && <div className={styles.sub} dangerouslySetInnerHTML={{ __html: alert.sub }} />}
					{alert.html && <br />}
					{alert.html}
				</div>
				<div className={styles.button_box}>
					{alert.confirm && (
						<button className={styles.button} onClick={(e) => onCancel(e, alert.id, alert.onCancel)}>
							{alert.cancel ?? "취소"}
						</button>
					)}
					<button className={`${styles.button} ${styles.button_ok}`} onClick={(e) => onOk(e, alert.id, alert.onOk)}>
						{alert.ok ?? "확인"}
					</button>
				</div>
				{alert.closeBtn && <i className='icon_select_close' onClick={(e) => App.hideAlert(alert.id)} />}
			</motion.div>
		</motion.div>
	)
}

const AlertLayer = ({ children, cancel, ok, onOk, onCancel, show, setShow, autoClose = true, closeBtn }) => {
	//#region Variants
	const App = useApp()
	const dimVariants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
		exit: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
	}

	const winVariants = {
		initial: {
			scale: 0,
			opacity: 0,
		},
		animate: {
			scale: 1,
			opacity: 1,
		},
		exit: {
			scale: 0,
			opacity: 0,
		},
	}
	//#endregion

	const onOkClick = () => {
		if (autoClose) setShow(false)
		onOk && onOk()
	}

	const onCancelclick = () => {
		if (autoClose) setShow(false)
		onCancel && onCancel()
	}

	return (
		<Portal>
			<AnimatePresence>
				{show && (
					<motion.div className={`${styles.Alert} ${styles.show}`} variants={dimVariants} initial='initial' animate='animate' exit='exit'>
						<motion.div className={styles.window} variants={winVariants}>
							<div className={styles.content}>{children}</div>
							<div className={styles.button_box}>
								{cancel && (
									<button className={styles.button} onClick={onCancelclick}>
										{cancel ?? "취소"}
									</button>
								)}
								{ok && (
									<button className={`${styles.button} ${styles.button_ok}`} onClick={onOkClick}>
										{ok ?? "확인"}
									</button>
								)}
							</div>
							{closeBtn && <i className='icon_select_close' onClick={(e) => setShow(false)} />}
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
}

export { AlertLayer }
export default Alert
